import React from "react";
import { useNavigate } from "react-router-dom";
import { Countdown, PlazasVIP } from "@/components/Offer";

export default function VipZone({ user }) {
  const navigate = useNavigate();
  const esVip = user?.role === "admin" || user?.role === "vip" || user?.vip_vitalicio;

  if (esVip) {
    return (
      <>
        <div className="main-head">
          <div><h1>Zona <span className="gold-it">VIP</span></h1><p className="sub">Acceso total · mentorías, grabaciones y comunidad privada.</p></div>
          <span className="chip">Miembro VIP Vitalicio</span>
        </div>
        <div className="cards" data-testid="vip-content">
          {[
            ["♛", "Grabaciones de mentorías", "Todas las sesiones semanales grabadas, organizadas por temática."],
            ["◈", "Recursos y plantillas VIP", "Propuestas comerciales, prompts y sistemas listos para vender."],
            ["◉", "Comunidad privada VIP", "Networking directo en España con el resto de miembros vitalicios."],
            ["✦", "Revisión de tu proyecto", "Feedback personalizado de tu negocio o portfolio en las llamadas."],
          ].map(([ico, t, p]) => (
            <div className="ccard" key={t} style={{ cursor: "default" }}>
              <span className="chip">{ico} VIP</span>
              <h3>{t}</h3>
              <div className="mini">{p}</div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="main-head">
        <div><h1>Zona <span className="gold-it">VIP</span></h1><p className="sub">Mentorías en directo, red privada y acceso total.</p></div>
      </div>
      <div className="vip-card" style={{ maxWidth: 560 }} data-testid="vip-offer">
        <div className="vip-inner">
          <span className="badge-oferta">🔥 Oferta de lanzamiento</span>
          <h3 style={{ marginTop: 18 }}>VIP VITALICIO</h3>
          <div className="vip-price"><span className="price-old">2.900 €</span>495 €<small> pago único</small></div>
          <div className="price-note">Solo las primeras <b>100 plazas</b>. Después, 2.900 €.</div>
          <PlazasVIP />
          <Countdown />
          <ul className="vip-list">
            <li>Acceso vitalicio a los 30 programas</li>
            <li>Mentoría grupal en directo cada semana, para siempre</li>
            <li>Comunidad privada VIP de España</li>
            <li>Revisión personalizada de tu proyecto</li>
            <li>Certificación oficial Liberti Club IA</li>
          </ul>
          <button className="btn btn-gold" data-testid="vip-comprar" style={{ width: "100%", justifyContent: "center" }}
            onClick={() => navigate("/checkout?tipo=vip")}>
            Reservar mi plaza vitalicia →
          </button>
          <div className="vip-alt">Cursos sueltos: <b>49,95 €/mes</b> cada uno</div>
        </div>
      </div>
    </>
  );
}
